<template>
  <div>
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <search-form ref="searchForm" v-if="showForm" :formData.sync="formData" :oLoading.sync="oLoading" @paginationChange="paginationChange">
      <template slot="custom-export">
        <slot name="custom-export"> </slot>
      </template>
    </search-form>
    <slot name="custom-operate"></slot>
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <base-table ref="baseTable"  :tableData.sync="tableData" @searchForm="searchForm" @setFormLoading="setFormLoading">
      <template slot="operation-group">
        <slot name="operation-group" />
      </template>
      <template slot="tools">
        <slot name="tools" />
      </template>
      <template slot="col-name-header">
        <slot name="col-name-heade" />
      </template>
      <template slot="col-name">
        <slot name="col-name" />
      </template>
  </base-table>
  </div>
</template>

<script>
import mixin from './mixins'

export default {
  name: 'BaseListManagement',
  data() {
    return {}
  },
  mixins: [mixin],
  methods: {},
}
</script>

<style lang="scss" scoped>
</style>
